// extracted by mini-css-extract-plugin
var _1 = "cs7Gc";
var _2 = "Mrwbm";
export { _1 as "base", _2 as "columns" }
